<template>
  <div class="cargo-pop-select-input">
    <el-input :value="valueLabel" @change="onChange" @click.native="dialogVisible=true" />
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="760px"
      append-to-body
    >
      <div class="operation" style="position: relative;margin-bottom: 10px">
        <div style="width: 260px;">
          <el-checkbox v-if="showAll" v-model="checkAll" style="margin-right: 10px;">{{ $t('CargoMsg.Cargo_All') }}{{ dialogTitle }}</el-checkbox>
          <el-button type="primary" @click="onSave">{{ $t('Message.Confirm') }}</el-button>
          <el-button @click="onReset">{{ $t('Message.Reset') }}</el-button>
        </div>
        <div style="display: flex;flex: 1;position: absolute;right:0;top: 0;">
          <span style="align-self:center;margin-right: 5px;">{{ $t('Message.Search') }}</span>
          <el-input v-model="searchValue" style="flex: 1" @input="selectedBak = [...selectedData]" />
        </div>
      </div>
      <div class="grid">
        <cargo-ag-grid
          :column-defs="colDefs"
          :grid-options="gridOptions"
          :row-data="filterData"
          :show-side-bar="false"
          @gridReady="onGridReady"
        />
      </div>
      <template slot="footer">
        <div style="display: flex;text-align: left;">
          <span class="blue">{{ $t('Message.CurrentlySelectedItem') }}</span>
          <div style="flex: 1;height: 50px;overflow-y: auto;text-align: left;word-break: break-word;margin-left: 5px">
            {{ selectedData.join(',') === 'ALLRG' ? $t('CargoMsg.Cargo_All') + dialogTitle : selectedData.join(',') }}
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import lang from '@/lang'
import ColumnUtils from '@/utils/ColumnUtils'
export default {
  name: 'CargoPopSelectInput',
  components: { CargoAgGrid },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: () => lang.t('Message.Port')
    },
    columnDefs: {
      type: Array,
      default: () => []
    },
    selectType: {
      type: String,
      default: () => 'basic_data_Seaport'
    },
    value: {
      type: String,
      default: () => ''
    },
    valueKey: {
      type: String,
      default: () => 'code'
    },
    filterKeys: {
      type: Array,
      default: () => ['code', 'englishName', 'chineseName']
    },
    useType: {
      type: Number,
      default: () => -1 // 0: 区域；1：国家；2：海港；3：空港；
    },
    showAll: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      isAll: false,
      dialogVisible: false,
      searchValue: '',
      gridOptions: {
        rowSelection: 'multiple',
        onRowSelected: this.onRowSelected
      },
      rowData: [],
      selectedData: [],
      selectedBak: [],
      defaultSeaportColumnDefs: [
        {
          colId: 'code',
          field: 'code',
          headerName: this.$t('Message.Code')
        }, {
          colId: 'chineseName',
          field: 'chineseName',
          headerName: this.$t('Message.ChineseName')
        }, {
          colId: 'englishName',
          field: 'englishName',
          headerName: this.$t('Message.EnglishName')
        }, {
          colId: 'countryCnName',
          field: 'countryCnName',
          headerName: this.$t('Message.Country')
        }, {
          colId: 'region',
          field: 'region',
          headerName: this.$t('Message.Region'),
          valueFormatter: (params) => {
            const { data } = params
            return this.$store.getters.language === 'zh' ? data.regionCnName : data.regionEnName
          }
        }
      ],
      defaultRegionColumnDefs: [
        {
          colId: 'code',
          field: 'code',
          headerName: this.$t('Message.Code')
        }, {
          colId: 'name',
          field: 'name',
          headerName: this.$t('Message.ChineseName')
        }, {
          colId: 'nameEnglish',
          field: 'nameEnglish',
          headerName: this.$t('Message.EnglishName')
        }
      ],
      defaultCountryColumnDefs: [
        {
          colId: 'code',
          field: 'code',
          headerName: this.$t('Message.Code')
        }, {
          colId: 'chineseName',
          field: 'chineseName',
          headerName: this.$t('Message.ChineseName')
        }, {
          colId: 'name',
          field: 'name',
          headerName: this.$t('Message.EnglishName')
        }, {
          colId: 'continent',
          field: 'continent',
          headerName: this.$t('Message.State')
        }
      ],
      valueLabel: ''
    }
  },
  computed: {
    colDefs() {
      const hide = this.value === 'ALLRG'
      const checkBoxRow = {
        colId: 'checkBox',
        checkboxSelection: true, sortable: false,
        headerCheckboxSelection: true, suppressMenu: true, resizable: false,
        hide: hide, suppressColumnsToolPanel: hide
      }
      if (this.useType === 0) {
        return [checkBoxRow, ...this.defaultRegionColumnDefs]
      }
      if (this.useType === 1) {
        return [checkBoxRow, ...this.defaultCountryColumnDefs]
      }
      if (this.useType === 2 || this.useType === 3) {
        return [checkBoxRow, ...this.defaultSeaportColumnDefs]
      }
      return [checkBoxRow, ...this.columnDefs]
    },
    checkAll: {
      get() {
        return this.selectedData.length > 0 && this.selectedData[0] === 'ALLRG'
      },
      set(val) {
        this.selectedData = val ? ['ALLRG'] : []
        this.isAll = val
      }
    },
    filterData() {
      const { searchValue, rowData } = this
      if (!searchValue.trim()) {
        return rowData
      } else {
        let filterKeys = this.filterKeys
        if (this.useType === 0) {
          filterKeys = ['code', 'name', 'nameEnglish']
        }
        if (this.useType === 1) {
          filterKeys = ['code', 'name', 'chineseName']
        }
        return rowData.filter(row => {
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            if (row[key] && row[key].toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) return true
          }
        })
      }
    },
    dialogTitle() {
      if (this.useType === 0) {
        return this.$t('CargoMsg.Cargo_Region')
      }
      if (this.useType === 1) {
        return this.$t('CargoMsg.Cargo_Country')
      }
      if (this.useType === 2 || this.useType === 3) {
        return this.$t('CargoMsg.Cargo_Port')
      }
      return this.title
    }
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      if (this.value) {
        this.selectedData = this.value.split(',')
      } else {
        this.selectedData = []
      }
      this.initValueLabel()
      if (!newVal) {
        return
      }
      this.initSelect(this.gridOptions.api)
    },
    filterData() {
      this.$nextTick(() => {
        this.selectedData = [...this.selectedBak]
        this.initSelect(this.gridOptions.api)
      })
    },
    checkAll(newVal) {
      this.$nextTick(() => {
        this.addOrRemoveCheckBox(newVal)
      })
    }
  },
  created() {
    let selectType = this.selectType
    if (this.useType === 0) {
      selectType = 'basic_data_Region'
    }
    if (this.useType === 1) {
      selectType = 'basic_data_Country'
    }
    if (this.useType === 2) {
      selectType = 'basic_data_Seaport'
    }
    if (this.useType === 3) {
      selectType = 'basic_data_Airport'
    }
    getSpecificBasicData(selectType).then(res => {
      this.rowData = res
    })
    this.initValueLabel()
  },
  methods: {
    onGridReady(params) {
      this.initSelect(params.api)
    },
    onChange(val) {
      console.info('this.val', val)
      this.$emit('change', val)
    },
    onRowSelected(params) {
      const { data: { code }, node: { selected }} = params
      const { selectedData } = this
      if (selected) {
        const index = selectedData.indexOf(code)
        if (index !== -1) {
          return
        }
        selectedData.push(code)
      } else {
        const index = selectedData.indexOf(code)
        if (index === -1) {
          return
        }
        selectedData.splice(index, 1)
      }
    },
    onSave() {
      console.info('this.selectedData', this.selectedData)
      this.$emit('change', this.selectedData.join(','))
      this.$emit('visible-change', false)
      this.handleClose()
    },
    onReset() {
      const { api } = this.gridOptions
      api.deselectAll()
      this.selectedBak = []
      this.searchValue = ''
      this.valueLabel = ''
    },
    handleClose() {
      this.dialogVisible = false
    },
    initSelect(gridApi) {
      if (!gridApi) {
        console.log('表格初始化未完成')
        return
      }
      const { selectedData, value, valueKey } = this
      if (value || (selectedData && selectedData.length)) {
        const { rowsToDisplay } = gridApi.getModel()
        rowsToDisplay.forEach(node => {
          const { data } = node
          const value = data[valueKey]
          const index = selectedData.indexOf(value)
          if (index !== -1) {
            node.setSelected(true)
          } else {
            node.setSelected(false)
          }
        })
      } else {
        gridApi.deselectAll()
      }
    },
    addOrRemoveCheckBox(val) {
      console.info('this.addOrRemoveCheckBox', val)
      if (val) {
        this.gridOptions.columnApi.setColumnVisible('checkBox', false)
        this.gridOptions.api.deselectAll()
      } else {
        this.gridOptions.columnApi.setColumnVisible('checkBox', true)
      }
    },
    initValueLabel() {
      const value = this.value
      this.valueLabel = ''
      if (!this.value) return
      let targetField = ''
      const isZh = this.$store.getters.language === 'zh'
      let cacheKey = ''
      if (this.useType === 0) {
        targetField = isZh ? 'name' : 'nameEnglish'
        cacheKey = 'basic_data_Region'
      } else if (this.useType === 1) {
        targetField = isZh ? 'chineseName' : 'name'
        cacheKey = 'basic_data_Country'
      } else if (this.useType === 2) {
        targetField = 'code'
        cacheKey = 'basic_data_Seaport'
      } else if (this.useType === 3) {
        targetField = 'code'
        cacheKey = 'basic_data_Airport'
      }
      const values = value.split(',')
      const valueName = []
      if (value === 'ALLRG') {
        valueName.push(this.$t('Pricing.ALLRG'))
      } else {
        for (const value of values) {
          const labelName = ColumnUtils.resolveColumnLabel(cacheKey, 'code', value, targetField)
          valueName.push(labelName)
        }
      }
      this.valueLabel = valueName.join()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.cargo-pop-select-input{
  .operation {
    display: flex;
    justify-content: space-between;
  }
  .grid {
    display: flex;
    height: 460px;
  }
  .el-dialog__footer{
    display: flex;
    text-align: left;
    .blue {
      color: $--color-primary
    }
  }
}

</style>
